import React from 'react';
import banner from '../../../images/branding.jpg';
const Branding = () => {
    return (
        <div>
            <img className='img-fluid' src={banner} alt="" />
        </div>
    );
};

export default Branding;